function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import PropTypes from 'prop-types';
import { validEmail } from '@domain-group/fe-helper';
import { AlertIcon } from '@domain-group/fe-co-icon';
import Loader from '@domain-group/fe-co-loader';
import { Button } from '@domain-group/fe-co-allhomes-design-system';
import UserInput from './user-input';
import Footer from './footer';
import * as styles from './sign-up.style';
import * as commonStyles from '../../style/common.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var ERROR_PASSWORD_INVALID = 3;
var ERROR_EMAIL_INVALID = 5;
var ERROR_EXISTING_ACCOUNT = 6;
var INTERNAL_ERROR = 99;
class SignUpPage extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "getFieldValue", key => this.state.signUpFields[key].value);
    _defineProperty(this, "getData", () => ({
      username: this.getFieldValue('username').trim(),
      firstName: this.getFieldValue('firstName').trim(),
      lastName: this.getFieldValue('lastName').trim(),
      password: this.getFieldValue('password').trim(),
      state: this.state.stateName
    }));
    _defineProperty(this, "submitForm", () => {
      if (!this.validate()) {
        return;
      }
      this.setState({
        isSubmitting: true,
        emailAddress: this.getFieldValue('username')
      });
      this.props.onSignUpClick(this.getData()).finally(() => this.setState({
        isSubmitting: false,
        isSubmitted: true
      }));
    });
    _defineProperty(this, "validateField", (key, value) => {
      var field = this.signUpFields[key];
      var error;
      if (field.required && !value) {
        error = field.requiredErrorMessage;
      } else if (field.validate) {
        error = field.validate(value);
      }
      return {
        value,
        error: error || ''
      };
    });
    _defineProperty(this, "validate", () => {
      var newState = this.allFields.reduce((state, key) => _objectSpread(_objectSpread({}, state), {}, {
        [key]: this.validateField(key, this.state.signUpFields[key].value.trim())
      }), {});
      this.setState({
        signUpFields: newState
      });
      return Object.values(newState).every(_ref => {
        var error = _ref.error;
        return !error;
      });
    });
    _defineProperty(this, "handleFieldChange", (key, value) => {
      var fieldState = {
        value,
        error: ''
      };
      this.setState(prevState => ({
        signUpFields: _objectSpread(_objectSpread({}, prevState.signUpFields), {}, {
          [key]: fieldState
        })
      }));
    });
    _defineProperty(this, "signInWithUsername", () => this.props.onSignInClick(this.getFieldValue('username')));
    _defineProperty(this, "renderField", (key, type, error) => {
      var field = this.signUpFields[key];
      var fieldState = this.state.signUpFields[key];
      return ___EmotionJSX(UserInput, _extends({
        iconName: field.icon,
        fieldType: type,
        fieldName: key,
        placeHolder: field.label,
        onValueChange: event => this.handleFieldChange(key, event.target.value)
      }, field.canSubmit ? {
        onSubmit: this.submitForm
      } : {}, {
        fieldError: error || fieldState.error,
        fieldValue: fieldState.value,
        focus: field.focus || false
      }));
    });
    _defineProperty(this, "checkError", code => {
      var error = this.props.error.filter(item => item.errorCode === code);
      return error.length > 0 ? error[0].message : '';
    });
    this.signUpFields = {
      username: {
        label: 'Email',
        icon: 'email',
        required: true,
        requiredErrorMessage: 'Email is required',
        validate: value => validEmail(value) ? '' : 'Please enter a valid email address'
      },
      firstName: {
        label: 'First Name',
        icon: 'profile',
        required: true,
        requiredErrorMessage: 'First name is required',
        focus: true
      },
      lastName: {
        label: 'Last Name',
        icon: 'profile',
        required: true,
        requiredErrorMessage: 'Last name is required'
      },
      password: {
        label: 'Password',
        icon: 'lock',
        required: true,
        requiredErrorMessage: 'Password is required',
        canSubmit: true
      }
    };
    this.allFields = Object.keys(this.signUpFields);
    this.state = {
      isSubmitted: false,
      isSubmitting: false,
      signUpFields: {
        username: {
          value: props.initialUsername,
          error: ''
        },
        firstName: {
          value: '',
          error: ''
        },
        lastName: {
          value: '',
          error: ''
        },
        password: {
          value: '',
          error: ''
        }
      },
      stateName: 'ACT',
      emailAddress: ''
    };
  }
  componentDidMount() {
    setTimeout(() => {
      document.getElementsByName('firstName')[0].focus();
    }, 1);
  }
  /* eslint-disable jsx-a11y/anchor-is-valid */
  render() {
    var _this$props = this.props,
      error = _this$props.error,
      privacyUrl = _this$props.privacyUrl,
      termsUrl = _this$props.termsUrl;
    return this.state.isSubmitted && error.length === 0 ? ___EmotionJSX("div", null, ___EmotionJSX("div", {
      css: commonStyles.confirmationTitle
    }, "One last step"), ___EmotionJSX("div", {
      css: commonStyles.confirmationHeaderContent
    }, "Your account's all set up, you just need to activate it.", ___EmotionJSX("br", null), "Check your inbox (or spam folder) at", ___EmotionJSX("span", {
      css: styles.bodyTextBold
    }, "\xA0", this.state.emailAddress), ___EmotionJSX("br", null), " ", ___EmotionJSX("br", null)), ___EmotionJSX("div", {
      css: styles.confirmButton
    }, ___EmotionJSX(Button, {
      css: styles.gotItButton,
      onClick: this.props.onCloseModalCallback
    }, "Got it"))) : ___EmotionJSX("div", null, ___EmotionJSX("div", {
      css: commonStyles.title
    }, "Create your account"), ___EmotionJSX("div", {
      css: commonStyles.subTitle
    }, "Add properties to watch list, create property alerts and many more."), this.state.isSubmitted && error.length > 0 && this.checkError(ERROR_EXISTING_ACCOUNT) && ___EmotionJSX("div", {
      css: commonStyles.formSubmitError
    }, ___EmotionJSX("div", {
      css: commonStyles.formSubmitErrorIcon
    }, ___EmotionJSX(AlertIcon, {
      size: "regular"
    })), ___EmotionJSX("div", {
      css: commonStyles.formSubmitErrorMessage
    }, ___EmotionJSX("div", {
      css: styles.errorMessageDetail
    }, "An account already exists with the email", ' ', ___EmotionJSX("span", {
      css: styles.bodyTextBold
    }, this.state.emailAddress)), ___EmotionJSX("div", null, "Either log in with this email or choose a different email address."))), this.state.isSubmitted && error.length > 0 && this.checkError(INTERNAL_ERROR) && ___EmotionJSX("div", {
      css: commonStyles.formSubmitError
    }, ___EmotionJSX("div", {
      css: commonStyles.formSubmitErrorIcon
    }, ___EmotionJSX(AlertIcon, {
      size: "regular"
    })), ___EmotionJSX("div", {
      css: commonStyles.formSubmitErrorMessage
    }, ___EmotionJSX("div", {
      css: styles.errorMessageDetail
    }, "Failed to submit request. Please try again later."))), ___EmotionJSX("div", {
      role: "form",
      id: "sign-up",
      "aria-label": "Sign up to Allhomes"
    }, ___EmotionJSX("div", {
      css: styles.signUpFields
    }, this.renderField('firstName', 'text'), this.renderField('lastName', 'text'), this.renderField('username', 'text', this.checkError(ERROR_EMAIL_INVALID)), this.renderField('password', 'password', this.checkError(ERROR_PASSWORD_INVALID))), ___EmotionJSX("div", {
      css: styles.terms
    }, "By signing up with Allhomes, I agree to the\xA0", ___EmotionJSX("a", {
      css: styles.termsLink,
      href: privacyUrl,
      target: "_blank",
      rel: "noreferrer"
    }, "Privacy Policy"), "\xA0and\xA0", ___EmotionJSX("a", {
      css: styles.termsLink,
      href: termsUrl,
      target: "_blank",
      rel: "noreferrer"
    }, "Terms & Conditions"), "."), ___EmotionJSX(Button, {
      css: commonStyles.submitButton,
      onClick: this.submitForm,
      disabled: this.state.isSubmitting
    }, this.state.isSubmitting ? ___EmotionJSX(Loader, {
      css: commonStyles.submitButtonLoader,
      dark: true,
      transparent: true,
      size: "mini"
    }) : 'Sign up'), ___EmotionJSX("div", {
      css: commonStyles.buttonDivider
    }), ___EmotionJSX("div", {
      css: commonStyles.buttonContainer
    }, "Already have an account?", ' ', ___EmotionJSX(Button, {
      css: styles.logInButton,
      appearance: "ghost",
      onClick: this.signInWithUsername
    }, ___EmotionJSX("span", {
      css: commonStyles.linkButtonText
    }, "Log in")))), ___EmotionJSX(Footer, {
      onCloseModal: this.props.onCloseModalCallback
    }));
  }
}
SignUpPage.propTypes = {
  initialUsername: PropTypes.string,
  onSignUpClick: PropTypes.func,
  onSignInClick: PropTypes.func,
  onForgotPasswordClick: PropTypes.func,
  privacyUrl: PropTypes.string,
  termsUrl: PropTypes.string,
  error: PropTypes.arrayOf(PropTypes.shape({})),
  onCloseModalCallback: PropTypes.func.isRequired
};
SignUpPage.defaultProps = {
  initialUsername: '',
  onSignUpClick: () => Promise.resolve(),
  onForgotPasswordClick: () => {},
  onSignInClick: () => {},
  privacyUrl: 'https://www.domain.com.au/group/privacy-policy/',
  termsUrl: 'https://www.domain.com.au/group/conditions-of-use/',
  error: []
};
export default SignUpPage;